/*
  eslint-disable flights/no-use-effect-in-controller
  -- this line was auto generated, hence fix the issue timely
*/
import { t, useI18n } from "@bookingcom/lingojs-react";
import useSearchFiltersController from "../../useSearchFiltersController";
import { useEffect, useState, useRef, useCallback } from "react";
import debounce from "lodash/debounce";

const useDebouncedCallback = <T extends (...args: any[]) => any>(callback: T, delay: number) => {
  const debouncedFn = useRef<ReturnType<typeof debounce>>();
  useEffect(() => {
    debouncedFn.current = debounce((...args: Parameters<T>) => {
      callback(...args);
    }, delay);
    return () => {
      debouncedFn.current?.cancel();
    };
  }, [callback, delay]);
  return useCallback((...args: Parameters<T>) => {
    debouncedFn.current?.(...args);
  }, []);
};

export const useDurationFilterController = () => {
  const i18n = useI18n();
  const { duration } = useSearchFiltersController();
  const [value, setValue] = useState(duration.value);
  const lastCommittedValueRef = useRef(duration.value);

  useEffect(() => {
    setValue(duration.value);
    lastCommittedValueRef.current = duration.value;
  }, [duration.value]);

  const debouncedDurationSet = useDebouncedCallback(duration.set, 300);

  const handleChangeCommit = (newValue: number) => {
    if (newValue !== lastCommittedValueRef.current) {
      lastCommittedValueRef.current = newValue;
      debouncedDurationSet(newValue);
    }
  };

  return {
    isFilterAvailable: duration.options.max !== duration.options.min,
    title: i18n.trans(t("flights_filters_duration_title")),
    resetLabel: i18n.trans(t("flights_filter_reset")),
    showReset: duration.touched,
    onClickReset: duration.reset,
    min: duration.options.min,
    max: duration.options.max,
    value,
    ariaLabel: i18n.trans(t("a11y_flights_filter_duration_announce")),
    label: i18n.trans(t("flights_filters_duration_travel_time_title")),
    onChange: (value: number) => setValue(value),
    onChangeCommit: handleChangeCommit,
    renderTooltipValue: (value: number) =>
      i18n.trans(
        t("flights_filters_duration_hours", { variables: { num_exception: value, num_hours: value.toString() } })
      ),
    renderValue: (value: number) =>
      i18n.trans(
        t("flights_filters_duration_hours", {
          variables: { num_exception: value, num_hours: value.toString() }
        })
      ),
    keyForRemount: `duration-${duration.options.min}-${duration.options.max}`
  };
};
